import { useEffect, useState } from 'react'

/**
 * Retourne la valeur "value" après un délai d'inactivité (delay ms).
 * Pratique pour éviter de spammer l’API pendant que l’utilisateur tape.
 */
export function useDebounce<T>(value: T, delay = 400): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(id)
  }, [value, delay])

  return debounced
}
